import { lazy } from 'react';

/** ECharts-based history chart, loaded on demand (keeps ECharts out of the main bundle). */
export const LazyHistoryChart = lazy(() => import('./HistoryChart'));
